export default __webpack_public_path__ + "static/media/2153.38e5a0c4.png";